import { RefundStep } from '@/classes/models'

export default class Refund {
  /**
   * Create new refund and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map steps to RefundStep
    if (typeof this.steps !== 'undefined') {
      this.steps = this.steps.map(step => new RefundStep(step))
    }
  }

  /**
   * @return {Date}
   */
  get createDateTimeUtc () {
    return this._createDateTimeUtc
  }

  /**
   * @param {string} value
   */
  set createDateTimeUtc (value) {
    this._createDateTimeUtc = new Date(value)
  }
}
